import React from "react";
import { RadioButton } from "@adserve/adserve-react-components";

//  Derived from BauerOptimiser RadioItem
//
const FontStyle = {
  fontFamily: "Roboto, Arial, sans-serif",
  letterSpacing: 0,
  fontWeight: 450,
  fontSize: 14,
  color: '#414141',
};

const RadioItem = ({label, checked, style, disabled = false, onClick}) => {
  const fontcolor = disabled ? { color: '#808080' } : {};
  return (
    <div
      style={{
        display: "flex",
        boxSizing: "border-box",
      }}
    >
      <div style={{ padding: "0 0 2px 1px" }}>
        <RadioButton
          value={checked}
          disabled={disabled}
          onClick={() => onClick(checked)}
        />
      </div>
      <div
        style={{
          cursor: disabled ? "" : "pointer",
          ...FontStyle,
          ...style,
          ...fontcolor,
        }}
        onClick={disabled ? undefined : () => onClick(checked)}
      >
        &nbsp;&nbsp;{label}
      </div>
    </div>
  )
}

export default RadioItem;